import React from "react";
import { useTranslation } from "react-i18next";

const Blockquote = () => {
    const { t } = useTranslation();
    return (
        <div className="bg-black flex justify-center items-center">
            <p className="text-2xl lg:text-4xl contain text-white font-bold text-center py-28 !w-[90vw] md:!w-[70vw] lg:!w-[60vw]">
                {t("blockquote.welcome")}
            </p>
        </div>
    );
};

export default Blockquote;
